export default __webpack_public_path__ + "static/media/icon-arrow-side-color-accent.70649bce.svg";